import { render, staticRenderFns } from "./WaitingInfoModal.vue?vue&type=template&id=0dc86d75"
import script from "./WaitingInfoModal.vue?vue&type=script&lang=js"
export * from "./WaitingInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports